<template>
    <div>
        <div class="col-md-12">
            <div class="panel panel-visible">
                <div class="panel-heading">
                    <div class="panel-title hidden-xs">
                        <span class="glyphicon glyphicon-plus"></span>Добавить схему</div>
                </div>
                <form v-on:submit.prevent="addSalaryScheme">
                    <div class="panel-body">

                        <div class="row">
                            <div class="col-md-4">
                                <input type="text" v-model="forms.add.name" class="form-control" placeholder="Название схемы">
                                <div v-if="$v.forms.add.$error === true" class="error">
                                    Заполните поле
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="panel-footer">
                        <input type="submit" class="btn btn-primary" value="Добавить">
                    </div>
                </form>
            </div>
        </div>
        <div class="col-md-12">
            <div class="panel panel-visible" id="spy2">

                <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"></loading>

                <div class="panel-heading">
                    <div class="panel-title hidden-xs">
                        <span class="glyphicon glyphicon-tasks"></span>Схемы выплат</div>
                </div>
                <div class="panel-body pn">
                    <per-pager v-bind:per-page="pagination.perPage"></per-pager>
                    <table class="table table-striped table-hover datatables" id="clients_list" cellspacing="0" width="100%">
                        <thead>
                            <tr>
                                <th>id</th>
                                <th>Наименование</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(salaryScheme, index) in salarySchemes" v-bind:key="index">
                                <td>{{salaryScheme.id}}</td>
                                <td>
                                    <router-link :to="{name: 'salary-scheme-edit', params: {id: salaryScheme.id}}">
                                        {{salaryScheme.name}}
                                    </router-link>
                                </td>
                                <td>
                                    <drop-down-button name="Действие" classes="btn-info btn-sm">
                                        <li>
                                            <a v-on:click="remove(salaryScheme)">
                                                Удалить
                                            </a>
                                        </li>
                                    </drop-down-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <paginator v-bind="pagination"></paginator>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DirectionSalaryScheme from "../../models/DirectionSalaryScheme";
    import { required } from 'vuelidate/lib/validators';
    import {validationMixin} from "vuelidate";

    export default {
        mixins: [validationMixin],
        components: {
            Loading: () => import('vue-loading-overlay'),
            Paginator: () => import('../data/Paginator'),
            PerPager: () => import('../data/PerPager'),
            dropDownButton: () => import('../data/DropDownButton'),
        },
        beforeMount() {
            this.load();
        },
        beforeRouteUpdate(to, from, next) {
            next();
            this.load();
        },
        data() {
            return {
                isLoading: false,
                pagination: {
                    currentPage: 0,
                    pageCount: 0,
                    perPage: 0,
                    totalCount: 0,
                },
                forms: {
                    add: {
                        name: '',
                    },
                },
                salarySchemes: [],
            };
        },
        watch: {
            'pagination.perPage': function(value) {
                this.setDefaultPerPage(value);
            },
        },
        validations: {
            forms: {
                add: {
                    name: {required},
                },
            },
        },
        methods: {
            load() {
                this.isLoading = true;
                const page = this.$route.query.page ? this.$route.query.page : 1;
                const perPage = this.$route.query['per-page'] ? this.$route.query['per-page'] : this.getDefaultPerPage();
                DirectionSalaryScheme.getList(page, perPage, undefined).then(({data, headers}) => {
                    this.setData(data, headers);
                    this.isLoading = false;
                });
            },
            getDefaultPerPage() {
                if (this.$store.state.template.perPages['salary-scheme-list-list']) {
                    return this.$store.state.template.perPages['salary-scheme-list-list'];
                }
                return 25;
            },
            setDefaultPerPage(value) {
                this.$store.commit('template/setPerPage', {name: 'salary-scheme-list-list', value: value})
            },
            setData(salarySchemes, headers) {
                this.salarySchemes = salarySchemes;
                this.pagination.currentPage = Number(headers['x-pagination-current-page']);
                this.pagination.pageCount = Number(headers['x-pagination-page-count']);
                this.pagination.perPage = Number(headers['x-pagination-per-page']);
                this.pagination.totalCount = Number(headers['x-pagination-total-count']);
            },

            addSalaryScheme() {
                let newSalaryScheme = new DirectionSalaryScheme({name: this.forms.add.name});
                newSalaryScheme.add().then((salaryScheme) => {
                    this.$router.push({name: 'salary-scheme-edit', params: {id: salaryScheme.id}});
                });
            },
            async remove(salaryScheme) {
                this.isLoading = true;
                await salaryScheme.remove(salaryScheme.id);
                this.load();
            }
        },
        metaInfo() {
            return {
                title: 'Схемы выплат - список',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>